"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreativeFormatFastStart {
    constructor({ enabled }) {
        this.toJSON = () => ({
            enabled: this.enabled,
        });
        this.enabled = enabled;
    }
}
CreativeFormatFastStart.fromJSON = (json) => {
    const { enabled } = Object.assign({}, json);
    if (typeof enabled !== 'boolean')
        throw new Error('.enabled must be a boolean');
    return new CreativeFormatFastStart({ enabled });
};
exports.default = CreativeFormatFastStart;
